export default __webpack_public_path__ + "static/media/124.06631e62.png";